var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3959_31353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#paint0_radial_3959_31353)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_3959_31353)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 346.044,
    ry: 138.506,
    transform: "matrix(-0.995683 -0.0928218 -0.123066 0.992398 1321.6 624.571)",
    fill: "#6366F1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_f_3959_31353)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 420.946,
    ry: 242.503,
    transform: "matrix(-0.998433 -0.0559618 -0.0743519 0.997232 1481.81 350.389)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2537 592.5C2537 592.224 2536.78 592 2536.5 592H1632.5C1592.46 592 1560 624.459 1560 664.5V1204.5C1560 1204.78 1560.22 1205 1560.5 1205C1560.78 1205 1561 1204.78 1561 1204.5V664.5C1561 625.012 1593.01 593 1632.5 593H2536.5C2536.78 593 2537 592.776 2537 592.5Z",
    fill: "url(#paint1_linear_3959_31353)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2540 534.5C2540 534.224 2539.78 534 2539.5 534H1593.5C1541.31 534 1499 576.309 1499 628.5V1193.5C1499 1193.78 1499.22 1194 1499.5 1194C1499.78 1194 1500 1193.78 1500 1193.5V628.5C1500 576.861 1541.86 535 1593.5 535H2539.5C2539.78 535 2540 534.776 2540 534.5Z",
    fill: "url(#paint2_linear_3959_31353)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2553 467.5C2553 467.224 2552.78 467 2552.5 467L1544.5 467C1482.37 467 1432 517.368 1432 579.5V1183.5C1432 1183.78 1432.22 1184 1432.5 1184C1432.78 1184 1433 1183.78 1433 1183.5V579.5C1433 517.92 1482.92 468 1544.5 468L2552.5 468C2552.78 468 2553 467.776 2553 467.5Z",
    fill: "url(#paint3_linear_3959_31353)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2557 393.5C2557 393.224 2556.78 393 2556.5 393L1484.5 393C1413.53 393 1356 450.531 1356 521.5V1173.5C1356 1173.78 1356.22 1174 1356.5 1174C1356.78 1174 1357 1173.78 1357 1173.5V521.5C1357 451.084 1414.08 394 1484.5 394L2556.5 394C2556.78 394 2557 393.776 2557 393.5Z",
    fill: "url(#paint4_linear_3959_31353)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2557 303.5C2557 303.224 2556.78 303 2556.5 303L1392.5 303C1319.32 303 1260 362.322 1260 435.5V1163.5C1260 1163.78 1260.22 1164 1260.5 1164C1260.78 1164 1261 1163.78 1261 1163.5V435.5C1261 362.875 1319.87 304 1392.5 304L2556.5 304C2556.78 304 2557 303.776 2557 303.5Z",
    fill: "url(#paint5_linear_3959_31353)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3959_31353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.962993 1080H-1.6051H-0.962993ZM0.160552 1080L524.733 1066.52C524.893 1071.01 524.893 1075.51 524.893 1080H7.39098e-05H0.160552ZM-0.802515 1080H-0.962993H-1.6051H-0.802515ZM-0.160405 1080H7.39098e-05H0.160552H0.321129H0.481608L520.399 1012.29C521.522 1021.27 522.485 1030.42 523.288 1039.57L0.321129 1080H0.160552H-0.160405H-0.642036H-0.160405ZM510.446 957.895C512.533 966.88 514.459 975.865 516.225 984.851L0.481608 1079.84L510.446 957.895ZM-0.160405 1080H0.160552H0.321129H-0.160405ZM494.716 904.784C497.766 913.449 500.655 922.274 503.223 931.099L0.321129 1079.84L494.716 904.784ZM473.688 853.76C477.701 862.104 481.393 870.447 484.924 878.951L0.481608 1079.68L473.688 853.76ZM7.39098e-05 1080H0.160552H7.39098e-05ZM447.363 805.464C452.179 813.326 456.673 821.188 461.168 829.211L0.642184 1079.84L447.363 805.464ZM7.39098e-05 1080L0.160552 1079.84L7.39098e-05 1080ZM0.160552 1080L416.223 760.376C421.841 767.596 427.138 774.977 432.274 782.519L0.321129 1079.84L0.160552 1080ZM7.39098e-05 1080L380.748 718.818C387.008 725.397 393.108 732.136 399.047 739.196L7.39098e-05 1080ZM7.39098e-05 1079.84L341.1 681.112C348.003 687.049 354.744 693.146 361.486 699.404L7.39098e-05 1079.84ZM7.39098e-05 1079.84V1079.68L297.6 647.898C305.144 653.032 312.528 658.488 319.751 663.943L7.39098e-05 1079.84ZM0.160552 1079.52L250.889 619.016C258.915 623.348 266.941 628.002 274.646 632.815L0.160552 1079.52ZM200.968 595.269C209.476 598.799 217.823 602.489 226.17 606.501L7.39098e-05 1079.52L200.968 595.269ZM148.961 576.817C157.789 579.384 166.618 582.272 175.285 585.321L0.160552 1079.36L148.961 576.817ZM7.39098e-05 1080V1079.84V1080ZM95.1871 563.981C104.337 565.585 113.326 567.511 122.154 569.757L0.160552 1079.52L95.1871 563.981ZM7.39098e-05 1080V1079.84V1080ZM7.39098e-05 1080V1079.84V1079.68L40.7716 556.921C49.9211 557.562 58.9101 558.525 68.0596 559.809L0.321129 1079.52V1079.68V1079.84L7.39098e-05 1080ZM7.39098e-05 1080V555.316C4.49457 555.316 8.98911 555.316 13.4836 555.477L7.39098e-05 1079.84V1080ZM7.39098e-05 555.316V1080H-0.160405H-0.642036H-0.802515H-0.962993H-1.6051V555.316H7.39098e-05ZM0.160552 1080L524.733 1066.52L990.073 1054.49C990.234 1062.99 990.395 1071.5 990.395 1080H7.39098e-05H0.160552ZM-0.802515 1080H-0.962993H-1.6051H-0.802515ZM-0.160405 1080H7.39098e-05H0.160552H0.321129H0.481608L520.559 1012.13L982.048 951.958C984.295 968.966 986.061 986.135 987.345 1003.3L523.288 1039.24L0.321129 1080H0.160552H-0.160405H-0.642036H-0.160405ZM0.481608 1079.84L510.446 957.895L963.107 849.588C967.119 866.436 970.811 883.444 973.861 900.613L516.065 984.851L0.481608 1079.84ZM-0.160405 1080H7.39098e-05H-0.160405ZM494.716 904.784L933.571 749.465C939.35 765.831 944.807 782.358 949.623 799.045L503.223 931.099L0.321129 1079.84L494.716 904.784ZM7.39098e-05 1080H0.160552H7.39098e-05ZM473.688 853.76L893.602 653.193C901.147 668.757 908.209 684.642 914.791 700.848L484.764 879.112L0.321129 1079.84L473.688 853.76ZM447.363 805.464L844.002 562.055C852.991 576.817 861.659 591.739 870.006 606.982L0.481608 1079.84L447.363 805.464ZM7.39098e-05 1080L0.160552 1079.84L7.39098e-05 1080ZM0.160552 1080L416.223 760.376L785.413 476.854C795.847 490.493 805.96 504.452 815.912 518.572L432.435 782.519L0.481608 1079.84L0.160552 1080ZM0.160552 1080L380.748 718.818L718.317 398.392C730.195 410.908 741.592 423.583 752.828 436.741L399.047 739.036L0.160552 1080ZM7.39098e-05 1079.84L341.1 681.112L643.516 327.472C656.678 338.703 669.359 350.096 681.879 361.969L361.326 699.404L7.39098e-05 1079.84ZM7.39098e-05 1079.84V1079.68L297.6 647.898L561.652 264.574C575.938 274.361 589.742 284.47 603.386 295.06L319.751 664.104L7.39098e-05 1079.84ZM0.160552 1079.52L473.206 210.34C488.456 218.684 503.384 227.348 518.151 236.334L274.485 632.815L0.160552 1079.52ZM200.968 595.269L379.303 165.413C395.355 172.152 411.247 179.212 426.977 186.593L226.33 606.501L0.160552 1079.52L200.968 595.269ZM148.961 576.817L280.906 130.595C297.6 135.569 314.294 140.864 330.506 146.64L175.125 585.321L7.39098e-05 1079.36L148.961 576.817ZM7.39098e-05 1080V1079.84V1080ZM0.160552 1079.52L95.1871 563.981L179.459 106.366C196.634 109.575 213.649 113.105 230.504 117.117L122.154 569.596L0.160552 1079.52ZM7.39098e-05 1080V1079.84V1080ZM7.39098e-05 1080V1079.84V1079.68L40.7716 556.921L76.7275 92.8882C93.9029 94.1718 111.078 96.0972 128.093 98.1831L67.8991 559.648L7.39098e-05 1079.52V1079.68V1079.84V1080ZM7.39098e-05 1080V90C8.50751 90 17.015 90.1605 25.5224 90.3209L13.4836 555.477L7.39098e-05 1079.84V1080ZM7.39098e-05 90V1080H-0.160405H-0.642036H-0.802515H-0.962993H-1.6051V90H7.39098e-05Z",
    fill: "url(#paint6_radial_3959_31353)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3959_31353",
    x: 626.616,
    y: 133.383,
    width: 1389.96,
    height: 982.377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_3959_31353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3959_31353",
    x: 611.131,
    y: -342.604,
    width: 1741.36,
    height: 1385.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_3959_31353"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3959_31353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1407.5 339.12) rotate(-48.9169) scale(2477.35 1281.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6387F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524709,
    stopColor: "#DA46EF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6387F1",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3959_31353",
    x1: 2537,
    y1: 899.967,
    x2: 1560,
    y2: 899.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3959_31353",
    x1: 2540,
    y1: 865.579,
    x2: 1499,
    y2: 865.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3959_31353",
    x1: 2553,
    y1: 827.215,
    x2: 1432,
    y2: 827.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3959_31353",
    x1: 2557,
    y1: 785.369,
    x2: 1356,
    y2: 785.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3959_31353",
    x1: 2557,
    y1: 735.56,
    x2: 1260,
    y2: 735.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3959_31353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-34.798 1138.81) rotate(-46.0678) scale(1058.92 1061.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3959_31353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3959_31353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 992,
    height: 990,
    fill: "white",
    transform: "matrix(-1 0 0 1 992 90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.2d5830d3353f205e118fa4983cc856d5.svg";
export { ForwardRef as ReactComponent };